var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "padding-top": "6px" },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: "160",
        height: "44",
        viewBox: "0 0 160 44"
      }
    },
    [
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "linear-gradient",
                y1: "0.5",
                x2: "1",
                y2: "0.5",
                gradientUnits: "objectBoundingBox"
              }
            },
            [
              _c("stop", { attrs: { offset: "0", "stop-color": "#7d338c" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#0071b6" } })
            ],
            1
          ),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "linear-gradient-2",
              x1: "0.002",
              y1: "0.501",
              x2: "1.001",
              y2: "0.501",
              "xlink:href": "#linear-gradient"
            }
          }),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "linear-gradient-3",
              x1: "0",
              y1: "0.5",
              x2: "1",
              y2: "0.5",
              "xlink:href": "#linear-gradient"
            }
          }),
          _vm._v(" "),
          _c("clipPath", { attrs: { id: "clip-Sorted_logo" } }, [
            _c("rect", { attrs: { width: "160", height: "44" } })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Sorted_logo",
            "data-name": "Sorted logo",
            "clip-path": "url(#clip-Sorted_logo)"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Group_1054",
                "data-name": "Group 1054",
                transform: "translate(-51.27 -163.18)"
              }
            },
            [
              _c(
                "g",
                { attrs: { id: "Group_1047", "data-name": "Group 1047" } },
                [
                  _c(
                    "g",
                    { attrs: { id: "Group_1046", "data-name": "Group 1046" } },
                    [
                      _c("path", {
                        attrs: {
                          id: "Path_1939",
                          "data-name": "Path 1939",
                          d:
                            "M109.95,189.61c-.03-.64-.53-1.12-1.43-1.12-.93,0-1.46.49-1.46,1.16,0,1.74,4.11.2,4.11,3.1,0,1.39-1.07,2.26-2.69,2.26-1.59,0-2.64-.84-2.68-2.22h1.12c.02.71.57,1.18,1.56,1.18,1.01,0,1.58-.47,1.58-1.18,0-1.74-4.09-.2-4.09-3.1a2.549,2.549,0,0,1,5.05-.06h-1.07Z",
                          fill: "#9953a0"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1940",
                          "data-name": "Path 1940",
                          d:
                            "M113.28,194.85h-1.13v-4.74a2.388,2.388,0,0,1,2.49-2.67,2.194,2.194,0,0,1,2.09,1.2h.02a2.185,2.185,0,0,1,2.09-1.2,2.384,2.384,0,0,1,2.49,2.67v4.74H120.2v-4.74c0-1.11-.61-1.62-1.44-1.62a1.415,1.415,0,0,0-1.44,1.62v4.74h-1.13v-4.74c0-1.09-.61-1.62-1.44-1.62s-1.44.51-1.44,1.62v4.74Z",
                          fill: "#9953a0"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1941",
                          "data-name": "Path 1941",
                          d:
                            "M126.42,189.61c-.03-.64-.53-1.12-1.43-1.12-.93,0-1.46.49-1.46,1.16,0,1.74,4.11.2,4.11,3.1,0,1.39-1.07,2.26-2.69,2.26-1.59,0-2.64-.84-2.68-2.22h1.12c.02.71.57,1.18,1.56,1.18,1.01,0,1.58-.47,1.58-1.18,0-1.74-4.09-.2-4.09-3.1a2.549,2.549,0,0,1,5.05-.06h-1.07Z",
                          fill: "#9953a0"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1942",
                          "data-name": "Path 1942",
                          d:
                            "M128.77,194.85v-7.27h5.25v1.04H129.9v2h3.48v1.04H129.9v3.18h-1.13Z",
                          fill: "#9953a0"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1943",
                          "data-name": "Path 1943",
                          d:
                            "M141.82,189.61c-.03-.64-.53-1.12-1.43-1.12-.93,0-1.46.49-1.46,1.16,0,1.74,4.11.2,4.11,3.1,0,1.39-1.07,2.26-2.69,2.26-1.59,0-2.64-.84-2.68-2.22h1.12c.02.71.57,1.18,1.56,1.18,1.01,0,1.58-.47,1.58-1.18,0-1.74-4.09-.2-4.09-3.1a2.549,2.549,0,0,1,5.05-.06h-1.07Z",
                          fill: "#9953a0"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1944",
                          "data-name": "Path 1944",
                          d:
                            "M146.71,194.99a2.891,2.891,0,1,1,2.95-2.89A2.824,2.824,0,0,1,146.71,194.99Zm1.89-2.89a1.89,1.89,0,1,0-1.89,1.91A1.811,1.811,0,0,0,148.6,192.1Z",
                          fill: "#9953a0"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1945",
                          "data-name": "Path 1945",
                          d:
                            "M154.22,191.68v-.07c0-1.01-.53-1.42-1.31-1.42s-1.31.41-1.31,1.42v3.23h-1.06v-3.23a2.365,2.365,0,1,1,4.73.01v.06Z",
                          fill: "#9953a0"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1946",
                          "data-name": "Path 1946",
                          d:
                            "M160.39,192.77a2.2,2.2,0,1,1-4.4,0v-5.29h1.06v1.88h3.02v.97h-3.02v2.44c0,.87.46,1.24,1.14,1.24a1.078,1.078,0,0,0,1.16-1.24v-.12h1.04Z",
                          fill: "#9953a0"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1947",
                          "data-name": "Path 1947",
                          d:
                            "M162.15,192.49v.02a1.751,1.751,0,0,0,1.84,1.5,1.682,1.682,0,0,0,1.53-.7h1.17a2.955,2.955,0,1,1,.23-1.21v.39Zm.04-.97v.02h3.63v-.02a1.9,1.9,0,0,0-3.63,0Z",
                          fill: "#9953a0"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1948",
                          "data-name": "Path 1948",
                          d:
                            "M173.47,192.06a2.777,2.777,0,0,1-2.93,2.93,2.824,2.824,0,0,1-2.96-2.89,2.736,2.736,0,0,1,2.77-2.89,2.253,2.253,0,0,1,2.04,1.08h.02v-3.33h1.06Zm-1.06.04a1.885,1.885,0,1,0-1.88,1.91A1.814,1.814,0,0,0,172.41,192.1Z",
                          fill: "#9953a0"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                { attrs: { id: "Group_1051", "data-name": "Group 1051" } },
                [
                  _c(
                    "g",
                    { attrs: { id: "Group_1049", "data-name": "Group 1049" } },
                    [
                      _c("path", {
                        attrs: {
                          id: "Path_1949",
                          "data-name": "Path 1949",
                          d:
                            "M84.75,179.78A15.13,15.13,0,0,1,99.1,190.1a8.765,8.765,0,0,0-4.82-12.52c0-.18.05-.34.05-.52A11.719,11.719,0,0,0,82.6,165.34l-.01.02a11.675,11.675,0,0,0-10.2,6,8.62,8.62,0,0,0-9.81,5.76c-.17,0-.34-.05-.52-.05a8.79,8.79,0,1,0,0,17.58h7.57A15.121,15.121,0,0,1,84.75,179.78Z",
                          fill: "url(#linear-gradient)"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: { id: "Group_1048", "data-name": "Group 1048" }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "Path_1950",
                              "data-name": "Path 1950",
                              d:
                                "M87.81,180.09a14.739,14.739,0,0,1,1.87.51,19.105,19.105,0,0,0,2.2-8.91,16.384,16.384,0,0,0-.09-1.87,11.749,11.749,0,0,0-2.3-2.21A17.116,17.116,0,0,1,87.81,180.09Z",
                              fill: "#fff",
                              opacity: "0.1"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              id: "Path_1951",
                              "data-name": "Path 1951",
                              d:
                                "M70.9,188.83a17.22,17.22,0,0,1-13.87-10.14,8.925,8.925,0,0,0-1.49,1.33,19.113,19.113,0,0,0,14.69,10.64A14.26,14.26,0,0,1,70.9,188.83Z",
                              fill: "#fff",
                              opacity: "0.1"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1952",
                          "data-name": "Path 1952",
                          d:
                            "M67.91,194.66h1.88a15.048,15.048,0,0,1,29.31-4.6,8.77,8.77,0,0,0,.93-2.72,16.942,16.942,0,0,0-32.14,7.32h.02Z",
                          fill: "#fff",
                          opacity: "0.1"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1953",
                          "data-name": "Path 1953",
                          d:
                            "M65.69,194.66a16.894,16.894,0,0,0-.81-21.05,8.633,8.633,0,0,0-1.24,1.46,15,15,0,0,1-.4,19.59Z",
                          fill: "#fff",
                          opacity: "0.1"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: {
                      id: "Ellipse_128",
                      "data-name": "Ellipse 128",
                      cx: "2.57",
                      cy: "2.57",
                      r: "2.57",
                      transform: "translate(88.23 186.5)",
                      fill: "#9953a0"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    { attrs: { id: "Group_1050", "data-name": "Group 1050" } },
                    [
                      _c("path", {
                        attrs: {
                          id: "Path_1954",
                          "data-name": "Path 1954",
                          d:
                            "M75.93,197.52a4.655,4.655,0,0,1,2.05-1.19.288.288,0,0,0,.21-.32,6.685,6.685,0,0,1,7.74-7.56.284.284,0,0,0,.33-.24,4.6,4.6,0,0,1,1.27-2.42h0a.291.291,0,0,0-.13-.49,10.087,10.087,0,0,0-12.32,12.47.29.29,0,0,0,.51.1C75.71,197.76,75.81,197.64,75.93,197.52Z",
                          fill: "url(#linear-gradient-2)"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1955",
                          "data-name": "Path 1955",
                          d:
                            "M94.07,192.34a4.565,4.565,0,0,1-2.42,1.27.3.3,0,0,0-.24.33,6.687,6.687,0,0,1-7.42,7.76.284.284,0,0,0-.31.22,4.654,4.654,0,0,1-1.21,2.14,3.584,3.584,0,0,1-.29.26.286.286,0,0,0,.11.5,10.085,10.085,0,0,0,12.28-12.37.3.3,0,0,0-.5-.11Z",
                          fill: "url(#linear-gradient-3)"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: {
                      id: "Ellipse_129",
                      "data-name": "Ellipse 129",
                      cx: "2.57",
                      cy: "2.57",
                      r: "2.57",
                      transform: "translate(76.63 198.22)",
                      fill: "#0071b6"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                { attrs: { id: "Group_1053", "data-name": "Group 1053" } },
                [
                  _c(
                    "g",
                    { attrs: { id: "Group_1052", "data-name": "Group 1052" } },
                    [
                      _c("path", {
                        attrs: {
                          id: "Path_1956",
                          "data-name": "Path 1956",
                          d:
                            "M117.09,174.11H114a5.879,5.879,0,0,0-.31-.79,2.26,2.26,0,0,0-.5-.69,2.171,2.171,0,0,0-.76-.47,2.9,2.9,0,0,0-1.07-.17,2.618,2.618,0,0,0-1.48.37,2.578,2.578,0,0,0-.86.94,3.832,3.832,0,0,0-.4,1.21,7.461,7.461,0,0,0-.1,1.2,7.554,7.554,0,0,0,.1,1.2,3.917,3.917,0,0,0,.4,1.21,2.55,2.55,0,0,0,.86.93,2.618,2.618,0,0,0,1.48.37,2.416,2.416,0,0,0,1.83-.65,3.392,3.392,0,0,0,.84-1.5h3.07a6.3,6.3,0,0,1-.49,1.73,6.187,6.187,0,0,1-.76,1.27,4.533,4.533,0,0,1-.92.89,5.944,5.944,0,0,1-1,.57,6.214,6.214,0,0,1-2.57.52,6.635,6.635,0,0,1-2.97-.7,5.744,5.744,0,0,1-1.08-.76,4.614,4.614,0,0,1-.95-1.16,6.764,6.764,0,0,1-.66-1.67,10.431,10.431,0,0,1,0-4.54,6.472,6.472,0,0,1,.67-1.68,5.08,5.08,0,0,1,2.05-1.95,6.59,6.59,0,0,1,2.97-.75,6.692,6.692,0,0,1,2.54.57,6.21,6.21,0,0,1,1,.59,4.394,4.394,0,0,1,.92.91,6.557,6.557,0,0,1,.76,1.28A7.277,7.277,0,0,1,117.09,174.11Z",
                          fill: "#203370"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1957",
                          "data-name": "Path 1957",
                          d: "M121.75,165.19v16.83h-3.04V165.19Z",
                          fill: "#203370"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1958",
                          "data-name": "Path 1958",
                          d:
                            "M123.32,175.71a9.057,9.057,0,0,1,.25-2.27,6.844,6.844,0,0,1,.66-1.68,4.515,4.515,0,0,1,.95-1.18,6.01,6.01,0,0,1,1.08-.77,6.59,6.59,0,0,1,2.97-.75,6.4,6.4,0,0,1,2.94.75,5.811,5.811,0,0,1,1.08.77,4.916,4.916,0,0,1,.95,1.18,6.844,6.844,0,0,1,.67,1.68,10.04,10.04,0,0,1,0,4.54,6.607,6.607,0,0,1-.67,1.67,4.409,4.409,0,0,1-.95,1.16,5.773,5.773,0,0,1-4.02,1.46,6.635,6.635,0,0,1-2.97-.7,5.744,5.744,0,0,1-1.08-.76,4.614,4.614,0,0,1-.95-1.16,6.764,6.764,0,0,1-.66-1.67A9.058,9.058,0,0,1,123.32,175.71Zm5.91-3.72a2.618,2.618,0,0,0-1.48.37,2.578,2.578,0,0,0-.86.94,3.832,3.832,0,0,0-.4,1.21,7.461,7.461,0,0,0-.1,1.2,7.554,7.554,0,0,0,.1,1.2,3.917,3.917,0,0,0,.4,1.21,2.55,2.55,0,0,0,.86.93,2.677,2.677,0,0,0,3.82-.93,3.832,3.832,0,0,0,.4-1.21,7.462,7.462,0,0,0,.1-1.2,7.553,7.553,0,0,0-.1-1.2,3.75,3.75,0,0,0-.4-1.21,2.659,2.659,0,0,0-.86-.94A2.7,2.7,0,0,0,129.23,171.99Z",
                          fill: "#203370"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1959",
                          "data-name": "Path 1959",
                          d:
                            "M142.19,182.26c-.05,0-.23-.01-.54-.02a5.085,5.085,0,0,1-1.08-.21,5.785,5.785,0,0,1-1.32-.59,4.625,4.625,0,0,1-1.3-1.15,6.057,6.057,0,0,1-.98-1.88,8.711,8.711,0,0,1-.39-2.8v-6.23h3.04v6.23a6.134,6.134,0,0,0,.1,1.12,3.363,3.363,0,0,0,.37,1.05,2.236,2.236,0,0,0,.77.79,2.965,2.965,0,0,0,2.64,0,2.236,2.236,0,0,0,.77-.79,3.053,3.053,0,0,0,.37-1.05,6.213,6.213,0,0,0,.1-1.12v-6.23h3.04v6.23a8.668,8.668,0,0,1-.39,2.8,6.384,6.384,0,0,1-.98,1.88,4.625,4.625,0,0,1-1.3,1.15,6.74,6.74,0,0,1-1.32.59,4.155,4.155,0,0,1-1.08.21C142.42,182.25,142.24,182.26,142.19,182.26Z",
                          fill: "#203370"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1960",
                          "data-name": "Path 1960",
                          d:
                            "M158.07,171.14v-5.96h2.97v10.5a9.057,9.057,0,0,1-.25,2.27,6.844,6.844,0,0,1-.66,1.68,4.845,4.845,0,0,1-.93,1.17,6.026,6.026,0,0,1-1.07.76,6.485,6.485,0,0,1-2.92.7,6.635,6.635,0,0,1-2.97-.7,5.744,5.744,0,0,1-1.08-.76,4.614,4.614,0,0,1-.95-1.16,6.763,6.763,0,0,1-.66-1.67,9,9,0,0,1-.25-2.27,9.582,9.582,0,0,1,.24-2.27,7.287,7.287,0,0,1,.62-1.68,5.017,5.017,0,0,1,.87-1.18,4.75,4.75,0,0,1,1.01-.77,5.742,5.742,0,0,1,2.74-.75,5.317,5.317,0,0,1,1.5.37,4.806,4.806,0,0,1,1.27.84,4.086,4.086,0,0,1,1.07,1.61Zm-2.87,8.28a2.618,2.618,0,0,0,1.48-.37,2.756,2.756,0,0,0,.87-.93,3.611,3.611,0,0,0,.41-1.21,7.461,7.461,0,0,0,.1-1.2,7.553,7.553,0,0,0-.1-1.2,3.611,3.611,0,0,0-.41-1.21,2.786,2.786,0,0,0-.87-.94,3.145,3.145,0,0,0-2.96,0,2.578,2.578,0,0,0-.86.94,3.832,3.832,0,0,0-.4,1.21,7.461,7.461,0,0,0-.1,1.2,7.553,7.553,0,0,0,.1,1.2,3.918,3.918,0,0,0,.4,1.21,2.55,2.55,0,0,0,.86.93A2.64,2.64,0,0,0,155.2,179.42Z",
                          fill: "#203370"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1961",
                          "data-name": "Path 1961",
                          d:
                            "M162.61,175.71a9.057,9.057,0,0,1,.25-2.27,6.844,6.844,0,0,1,.66-1.68,4.515,4.515,0,0,1,.95-1.18,6.01,6.01,0,0,1,1.08-.77,6.59,6.59,0,0,1,2.97-.75,6.4,6.4,0,0,1,2.94.75,5.811,5.811,0,0,1,1.08.77,4.916,4.916,0,0,1,.95,1.18,6.844,6.844,0,0,1,.67,1.68,10.04,10.04,0,0,1,0,4.54,6.607,6.607,0,0,1-.67,1.67,4.409,4.409,0,0,1-.95,1.16,5.773,5.773,0,0,1-4.02,1.46,6.635,6.635,0,0,1-2.97-.7,5.744,5.744,0,0,1-1.08-.76,4.614,4.614,0,0,1-.95-1.16,6.763,6.763,0,0,1-.66-1.67A9.057,9.057,0,0,1,162.61,175.71Zm5.91-3.72a2.618,2.618,0,0,0-1.48.37,2.578,2.578,0,0,0-.86.94,3.832,3.832,0,0,0-.4,1.21,7.461,7.461,0,0,0-.1,1.2,7.553,7.553,0,0,0,.1,1.2,3.918,3.918,0,0,0,.4,1.21,2.55,2.55,0,0,0,.86.93,2.677,2.677,0,0,0,3.82-.93,3.832,3.832,0,0,0,.4-1.21,7.461,7.461,0,0,0,.1-1.2,7.553,7.553,0,0,0-.1-1.2,3.832,3.832,0,0,0-.4-1.21,2.659,2.659,0,0,0-.86-.94A2.7,2.7,0,0,0,168.52,171.99Z",
                          fill: "#203370"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1962",
                          "data-name": "Path 1962",
                          d:
                            "M181.58,170.27v2.82h-2.62v8.93H176V168.88a3.375,3.375,0,0,1,.54-2.03,3.958,3.958,0,0,1,1.18-1.11,4.337,4.337,0,0,1,1.75-.55h3.49V168h-2.34a1.77,1.77,0,0,0-.92.2,1.575,1.575,0,0,0-.5.45,1.178,1.178,0,0,0-.22.65v.97h2.6Z",
                          fill: "#203370"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1963",
                          "data-name": "Path 1963",
                          d:
                            "M190.06,170.27v2.82h-2.62v8.93h-2.97V168.88a3.375,3.375,0,0,1,.54-2.03,3.958,3.958,0,0,1,1.18-1.11,4.337,4.337,0,0,1,1.75-.55h3.49V168h-2.34a1.77,1.77,0,0,0-.92.2,1.575,1.575,0,0,0-.5.45,1.178,1.178,0,0,0-.22.65v.97h2.61Z",
                          fill: "#203370"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1964",
                          "data-name": "Path 1964",
                          d:
                            "M192.92,166.56c0-.37,0-.64.01-.82a.567.567,0,0,1,.15-.4.726.726,0,0,1,.45-.14c.21-.01.51-.01.91-.01s.7,0,.91.01a.669.669,0,0,1,.45.14.567.567,0,0,1,.15.4c.01.18.01.46.01.82s0,.64-.01.82a.567.567,0,0,1-.15.4.726.726,0,0,1-.45.14c-.21.01-.51.01-.91.01s-.7,0-.91-.01a.669.669,0,0,1-.45-.14.567.567,0,0,1-.15-.4C192.93,167.2,192.92,166.92,192.92,166.56Zm3.05,2.81v12.64h-3.04V169.37Z",
                          fill: "#203370"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Path_1965",
                          "data-name": "Path 1965",
                          d:
                            "M203.07,174.36c.23,0,.55,0,.96.01a12.691,12.691,0,0,1,1.31.1,8.866,8.866,0,0,1,1.41.3,4.322,4.322,0,0,1,1.28.61,3.248,3.248,0,0,1,.93,1.02,3.064,3.064,0,0,1,.36,1.55,3.788,3.788,0,0,1-.64,2.31,4.187,4.187,0,0,1-1.56,1.31,6.1,6.1,0,0,1-1.98.57,16.925,16.925,0,0,1-1.88.12c-.1,0-.32,0-.65-.01a6.842,6.842,0,0,1-1.16-.14,8.577,8.577,0,0,1-1.4-.4,4.393,4.393,0,0,1-1.35-.79,4,4,0,0,1-1.01-1.32,4.4,4.4,0,0,1-.4-1.98h3.04a2.349,2.349,0,0,0,.07.54,1.417,1.417,0,0,0,.35.61,2.138,2.138,0,0,0,.82.51,4.733,4.733,0,0,0,1.5.24,9.029,9.029,0,0,0,1.81-.1,2.239,2.239,0,0,0,.93-.34.84.84,0,0,0,.36-.44,1.636,1.636,0,0,0,.06-.42,1.756,1.756,0,0,0-.07-.45.8.8,0,0,0-.39-.41,3.144,3.144,0,0,0-.97-.31,12.609,12.609,0,0,0-1.83-.15,8.392,8.392,0,0,1-1.79-.25,5.355,5.355,0,0,1-1.62-.69,3.81,3.81,0,0,1-1.17-1.16,2.953,2.953,0,0,1-.45-1.65,3.6,3.6,0,0,1,.45-1.83,3.813,3.813,0,0,1,1.18-1.28,5.588,5.588,0,0,1,1.68-.75,7.644,7.644,0,0,1,1.99-.25,11.866,11.866,0,0,1,1.47.12,5.6,5.6,0,0,1,1.81.57,4.243,4.243,0,0,1,1.52,1.32,3.831,3.831,0,0,1,.61,2.37h-3.04a1.577,1.577,0,0,0-.54-1.26,2.965,2.965,0,0,0-1.91-.46,3.1,3.1,0,0,0-1.65.39,1.182,1.182,0,0,0-.62,1.06.941.941,0,0,0,.6.92A3.718,3.718,0,0,0,203.07,174.36Z",
                          fill: "#203370"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }